module.exports = __webpack_public_path__ + "static/ready-to-go-img-402d06d5c9dc742fbd65aa1a42fdf76a.png";